export default function capitilize(string) {
  if (typeof string === 'string') {
    return string.replace(/(?:^|\s)\S/g, (a) => a.toUpperCase())
  }

  return string
}
